export default class File {
  static getList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaFile/list', 'post', data, axiosOption, httpOption);
  }
    
  static createdFile (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaFile/add', 'post', data, axiosOption, httpOption);
  }
  
  static updateCityProject (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/updateDatasource/oaFormCityProjecttest', 'post', data, axiosOption, httpOption);
  }
    
  static deleteFile (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaFile/delete', 'post', data, axiosOption, httpOption);
  }
}
